import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        {/* Content */}
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 mb-5 leading-[1.15]">
          Start Using the OOPBuy<br />Spreadsheet System Today
        </h2>
        <p className="text-foreground-600 text-base md:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
          Access structured product listings, compare prices, and simplify your sourcing workflow with the spreadsheet-based shopping system.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-primary-500 hover:bg-primary-600 transition-colors text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer"
          >
            Enter Spreadsheet System
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
          <Link
            to="/oopbuy-spreadsheet-guide"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-foreground-300 hover:bg-background-100 transition-colors text-foreground-800 font-medium text-sm whitespace-nowrap cursor-pointer"
          >
            Read Full Guide
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>

      {/* Bottom Image Banner */}
      <div className="mt-20 w-full overflow-hidden">
        <div className="flex gap-0">
          <div className="flex-shrink-0 w-full h-48 md:h-64 relative">
            <img
              src="https://readdy.ai/api/search-image?query=Horizontal%20flat%20lay%20product%20photography%20featuring%20various%20minimalist%20fashion%20items%20including%20neutral%20toned%20clothing%20accessories%20and%20footwear%20arranged%20in%20a%20clean%20row%20on%20pure%20white%20studio%20surface%20soft%20natural%20daylight%20editorial%20aesthetic%20floating%20composition%20high%20resolution&width=2000&height=400&seq=cta-footer-banner-01&orientation=landscape"
              alt="OOPBuy Spreadsheet product collection"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}